import { profileVisitorCards as TYPES } from './../action_types.wjs.jsx';
import { map as _map } from 'underscore';

const initialState = {
  models: [],
  meta: {
    cursor: null,
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

export function ProfileVisitorCards(state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_PROFILE_VISITOR_CARDS_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, { fetching: true }),
      });

    case TYPES.FETCH_PROFILE_VISITOR_CARDS_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.profileVisitorCards),
        meta: Object.assign({}, state.meta, {
          exhausted: action.exhausted,
          cursor: action.cursor,
          fetching: action.fetching,
          errorFetching: false,
        }),
      });

    case TYPES.UPDATE_PROFILE_VISITOR_CARD:
      var models = _map(state.models, function (profileVisitorCard) {
        return profileVisitorCardid === action.profileVisitorCard.id
          ? Object.assign({}, profileVisitorCard, action.profileVisitorCard)
          : profileVisitorCard;
      });

      return Object.assign({}, state, { models: models });

    case TYPES.UPDATE_PROFILE_VISITOR_CARDS_META:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, action.meta),
      });

    default:
      return state;
  }
}

export default ProfileVisitorCards;
